import React from 'react';
import Logo from './Logo';
import LogoCloud from './LogoCloud';
import { createStyledComponent } from '@cloudflare/style-container';
import { isDarkMode, variables as theme } from '@cloudflare/style-const';
export var LogoWrapper = createStyledComponent(_ref => {
  var {
    removeMargin
  } = _ref;
  return {
    my: removeMargin ? 0 : 2,
    userSelect: 'none',
    '-webkit-tap-highlight-color': 'rgba(0, 0, 0, 0)'
  };
});
export var DesktopOnly = createStyledComponent(_ref2 => {
  var {
    removeMargin
  } = _ref2;
  return {
    display: 'none',
    mx: removeMargin ? 0 : 3,
    tabletWide: {
      display: 'block'
    }
  };
});
export var MobileOnly = createStyledComponent(_ref3 => {
  var {
    removeMargin
  } = _ref3;
  return {
    display: 'block',
    mx: removeMargin ? 0 : 2,
    tabletWide: {
      display: 'none'
    }
  };
});

var LogoHeader = () => /*#__PURE__*/React.createElement(LogoWrapper, null, /*#__PURE__*/React.createElement(DesktopOnly, null, /*#__PURE__*/React.createElement(Logo, {
  textColor: isDarkMode() ? theme.colors.black : undefined
})), /*#__PURE__*/React.createElement(MobileOnly, null, /*#__PURE__*/React.createElement(LogoCloud, {
  width: "70px",
  height: "41px"
})));

export default LogoHeader;